module.exports = __webpack_public_path__ + "static/media/Lato-Regular.8ab18d93.eot";